import { ILoadableWrapper, ILoggedInUser, Loadable, createDefaultLoadable } from '../../models';
import { IMediaMTXToken } from '../../models/auth.model';

export interface UserState extends Loadable {
    authToken: string;
    mediaMTXToken: IMediaMTXToken | null;
    user: ILoggedInUser | null;
    code: ILoadableWrapper<{code: string}>;
    adminUnlocked: boolean;
}

export const initialAuthState: UserState = {
    ...createDefaultLoadable(),
    authToken: "",
    mediaMTXToken: null,
    user: null,
    code: {
        ...createDefaultLoadable(),
        code: ""
    },
    adminUnlocked: false,
};
